import React from "react";
import DateField from "@/ui/forms/DateField";
import { FilterInputProps } from "./FilterInput.types";
import { FILTER_INPUT_HEIGHTS } from "../../DataTable.theme";

/**
 * Date filter input component.
 */
export const DateFilter: React.FC<FilterInputProps> = ({
  value,
  onChange,
  density = "standard",
  placeholder = "Seleziona data...",
}) => {
  return (
    <DateField
      value={value ? new Date(value as string) : null}
      onChange={(date) => onChange(date ? date.toISOString() : null)}
      placeholder={placeholder}
      fullWidth
      clearable
      datePickerStyle={{
        "& .MuiInputBase-root": {
          fontSize: density === "compact" ? "0.75rem" : "0.875rem",
          height: FILTER_INPUT_HEIGHTS[density],
        },
      }}
    />
  );
};
